import { Aurelia, autoinject, bindable, bindingMode } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { AuthService } from 'DataAccessLayer/Services/AuthService';
import { DataService } from 'DataAccessLayer/Services/DataService';
import { ValidationHelper } from './Code/Helpers/ValidationHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { Toastr } from 'Code/Extension/Toastr';

@autoinject
export class Register {

    private _authService: AuthService = null;
    protected router: Router = null;
    private dataService: DataService = null;
    private validationHelper: ValidationHelper = null;

    private emailExists: boolean = false;

    private email: string = null;
    private firstName: string = null;
    private lastName: string = null;
    private company: string = null;
    private homebase: string = null;
    private broker: boolean = false;
    private passenger: boolean = false;
    private requestCounter: number = 0
    private showRegisterBtn: boolean = true;
    private iagree: boolean = false;

    constructor(authService: AuthService, dataService: DataService, router: Router, validationHelper: ValidationHelper) {
        this._authService = authService;
        this.dataService = dataService;
        this.validationHelper = validationHelper;
        this.router = router;
    }

    bind() {
    }

    private async emailBlur() {
        if (StringHelper.StringIs(this.email)) {
            const filterData: any = {
                "Email1": this.email
            }
            let response = await this.dataService.GetGridIds('PJCustomer', filterData, null, null, null, false, null);
            const gridIds = response['data'];
            this.emailExists = ObjectHelper.ArrayIs(gridIds);

        }
        else {
            this.emailExists = false;
        }
    }

    private async Register() {
        if (this.iagree == true) {
            if (StringHelper.StringIs(this.firstName) && StringHelper.StringIs(this.lastName) && StringHelper.StringIs(this.email)) {
                let params: any = {
                    "FirstName": this.firstName,
                    "LastName": this.lastName,
                    "Email": this.email,
                    "Company": this.company,
                    "Homebase": this.homebase,
                    "Broker": this.broker,
                    "Passenger": this.passenger,
                    "RequestCounter": 1
                }
                this.requestCounter = this.requestCounter + 1;
                params.RequestCounter = this.requestCounter;

                let apiResponse: any = await this.dataService.GetSpData('sp_BirdReviewRegister', params);
                if (ObjectHelper.ObjectIs(apiResponse) && ObjectHelper.ObjectIs(apiResponse.data)
                    && ObjectHelper.ObjectIs(apiResponse.data.ResponseCounter) && apiResponse.data.ResponseCounter > 0 && apiResponse.data.ResponseCounter == this.requestCounter) {
                    const resultObj: any = JSON.parse(JSON.stringify(apiResponse.data));
                    //console.log(55555, resultObj);
                    if (ObjectHelper.ObjectIs(resultObj) && ObjectHelper.ObjectIs(resultObj.RegisterDone) && resultObj.RegisterDone == true) {
                        this.showRegisterBtn = false;
                        Toastr.Success('Login information was sent to the provided email address.', 'Toastr.SavingFormWasSuccessful');
                    }
                    else {
                        Toastr.ErrorSimple(resultObj.Message);
                    }
                }
                else {
                    Toastr.ErrorSimple('Register Error');
                }
            }
            else {
                //console.log(5555, StringHelper.StringIs(this.firstName), StringHelper.StringIs(this.lastName), StringHelper.StringIs(this.email), StringHelper.StringIs(this.firstName) && StringHelper.StringIs(this.lastName) && StringHelper.StringIs(this.email));
                Toastr.ErrorSimple('E-mail, First and Last name are required');
            }
        }
        else {
            Toastr.ErrorSimple('You must agree to the terms and conditions listed at the bottom of this page');
        }
    }

}